import React from 'react';
import SearchResultsListItem from './search-results-list-item';


class SearchResultsList extends React.Component {
  render(){
    const { items, onItemClick, selectedIdx } = this.props;
    return (
      <ul className="list-group thin-scrollbar" ref={(el) => {this.el = el}} style={{position:'absolute', maxHeight: '400px', overflow: 'auto'}}>
        {
          items.map((item, i) => {
            if (typeof item == 'function') {
              return item().map( (subItem) => <SearchResultsListItem onClick={onItemClick} item={subItem} key={i} selected={selectedIdx === i}/>)
            }
            return <SearchResultsListItem onClick={onItemClick} item={item} key={i} selected={selectedIdx === i}/>
          })
        }
      </ul>
    )
  }
}

export default SearchResultsList;